import { axiosPrivate } from '@/shared/api/axios'
import { API } from '@/shared/constants/api'

export interface ISocietyLookup {
  _id: string
  id: string
  /**
   * El `soc_` con el que v2 direcciona esta sociedad. Viaja al lado del `_id` para que
   * un select pueda quedarse en este lookup y aun así resolver lo elegido a una
   * referencia v2, cruzando por clave primaria del mismo documento. Ver ADR 0027.
   *
   * Opcional porque el schema lo declara así: un registro anterior al backfill no lo
   * tiene, y quien traduce debe FALLAR en vez de mandar `undefined`.
   */
  publicId?: string | null
  name: string
  company: string
}

/**
 * Lookup legacy para selects. El CRUD/listado admin vive en
 * societies-admin.service.ts (contrato paginado estándar).
 */
export const societiesService = {
  getLookup: () => axiosPrivate.get<ISocietyLookup[]>(API.societies.lookup).then((r) => r.data)
}
